import { render, staticRenderFns } from "./main.vue?vue&type=template&id=ed581ca2&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=ed581ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed581ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed581ca2')) {
      api.createRecord('ed581ca2', component.options)
    } else {
      api.reload('ed581ca2', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=ed581ca2&scoped=true&", function () {
      api.rerender('ed581ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/SButton/main.vue"
export default component.exports